import React from "react";
import { twMerge } from "tailwind-merge";
import { type SwitcherProps, SupSwitcher } from "@repo/core-ui";

import { useField } from "../hooks";

export interface SwitchFieldProps extends SwitcherProps {
  name: string;
}

export function SupSwitchField({ name, id = name, label, className, disabled, value, defaultChecked, labelClassName, orientation }: SwitchFieldProps) {
  const { value: checked = false, onChange, onBlur } = useField<boolean>({ name });

  return (
    <SupSwitcher
      name={name}
      checked={checked}
      id={id}
      label={label}
      className={twMerge(className, "hover:opacity-60 transition-opacity duration-200", checked ? "opacity-100" : "opacity-44")}
      disabled={disabled}
      value={value}
      defaultChecked={defaultChecked}
      labelClassName={labelClassName}
      orientation={orientation}
      inputProps={{ onChange, onBlur }}
    />
  );
}
